import { useState, useEffect } from 'react';
import { useApi, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { RebacExplorerClient } from '../api/RebacExplorerClient';

/**
 * Retorna true se o usuário tem can_view no recurso `plugin:<pluginId>`.
 * Enquanto carrega, retorna undefined.
 */
export function useCanViewPlugin(pluginId: string): boolean | undefined {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [allowed, setAllowed] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const client = new RebacExplorerClient({ discoveryApi, fetchApi });
    client
      .getGrants('plugin', pluginId)
      .then(data => setAllowed(data.can_view))
      .catch(() => setAllowed(false));
  }, [pluginId]); // eslint-disable-line react-hooks/exhaustive-deps

  return allowed;
}
